import { createGlobalStyle } from 'styled-components';
import { ThemeProviderColors, ThemeProps } from '../interfaces';
import { colorPallet } from '../theme/colors';

export const DatePickerStyles = createGlobalStyle`

  .ms-Callout-main [class*='ms-slideDownIn'] [class*='root-'],
  [class*='monthPickerWrapper-'],
  .ms-Callout-main [class*='ms-slideDownIn'] [class*='root-'] [class*='dayCell-']:not(:disabled):hover,
  [class*='currentItemButton-']:hover  {
    background-color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.popupInputMainBackground};
  }

  .ms-Callout-main [class*='ms-slideDownIn'] [class*='root-'] [class*='dayButton-']:not(:disabled) {
    color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.textMainColor};
  }

  .ms-Callout-main [class*='ms-slideDownIn'] [class*='root-'] [class*='dayButton-']:disabled,
  [class*='itemButton-']:disabled,
  [class*='itemButton-']:hover {
    color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.datePickerDisabledDates};
      background-color: ${(props: ThemeProps<ThemeProviderColors>) =>
        props.theme.popupInputMainBackground};
  }

  [class*='weekDayLabelCell-'] {
    color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.textMainColor};
    font-weight: 400;
  }

  [class*='itemButton-'],
  [class*='monthAndYear-'] span,
  [class*='currentItemButton-'] span,
  [class*='itemButton-']:hover,
  [class*='goTodayButton-']:not(:disabled) {
    color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.textMainColor};
  }

  [class*='statusMessage-'] {
    display: none;
  }

  [class*='navigationButton-'] [data-icon-name*='Down'],
  [class*='navigationButton-'] [data-icon-name*='Up'],
  [class*='headerIconButton-'] [data-icon-name*='Down'],
  [class*='headerIconButton-'] [data-icon-name*='Up'] {
    color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.textMainColor};
  }

  [class*='disabled-'] [data-icon-name*='Up'],
  [class*='disabledStyle-'] [data-icon-name*='Up'] {
    color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.textMainColor};
  }

  [class*='navigationButton-']:hover,
  [class*='headerIconButton-']:hover {
    background-color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.popupInputMainBackground};
  }

  [class*='ms-CalendarDay-daySelected'][aria-selected*="true"][aria-current*="date"] [class*='dayIsToday-'],
  #fluent-default-layer-host [class*='dayIsToday-'] {
    border-radius: 6px;
    background-color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.selectedDateBackground} !important;
  }

  #fluent-default-layer-host [aria-current*="date"],
  [class*='ms-CalendarDay-daySelected'][aria-disabled*="true"] {
    border-radius: 6px;
    background-color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.selectedDateBackground} !important;
  }

  [class*='ms-CalendarDay-daySelected'][aria-selected*="true"]:before,
  [class*='dayOutsideBounds-']:before {
    border-right: 5px solid ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.selectedDateBackground};
    border-left: 5px solid ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.selectedDateBackground};
    border-bottom: 5px solid ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.selectedDateBackground};
    border-top: 5px solid ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.selectedDateBackground};
    border-radius: 6px;
    background-color: unset;
  }

  [class*='ms-CalendarDay-daySelected'][aria-selected*="true"] {
    border-radius: 8px;
  }

  [class*='ms-CalendarDay-daySelected'] [id*='id__'],
  [class*='ms-CalendarDay-daySelected'] [class*='dayButton-'] {
    background-color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.selectedDateBackground};
  }

  [class*='ms-CalendarDay-daySelected'] [id*='id__'] span {
    color: ${colorPallet.white};

  }

  #fluent-default-layer-host [class*="root-"] [class*="header-"] {
    border-bottom: 0.78px solid ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.datePickerBorderColor};
  }

  [id*="TextFieldDescription"] {
    display: none;
  }
  
  #fluent-default-layer-host i[class*="root-"] {
    opacity: 0;
    position: relative;
    width: 100%;
  }

  #fluent-default-layer-host [class*="headerIconButton-"] {
    &::before {
      content: "";
      position: absolute;
      top: 60%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-45deg);
      width: 8px;
      height: 8px;
      border-top: 1.5px solid ${(props: ThemeProps<ThemeProviderColors>) =>
        props.theme.textMainColor};
      border-right: 1.5px solid ${(props: ThemeProps<ThemeProviderColors>) =>
        props.theme.textMainColor};
   }
  }

  #fluent-default-layer-host [class*="headerIconButton-"]:not(:first-of-type) {
    &::before {
      transform: translate(-50%, -100%) rotate(135deg);
   }
  }

  @media (max-width: 710px) {
    [id*='startDate-label'],
    [id*='endDate-label'] {
      box-sizing: border-box;
      padding: 4px 10px;
      font-size: 14px;
    }

    [data-icon-name*="Calendar"] {
      display: flex;
      align-items: center;
    }
  }
`;
